import { axiosInstance } from '@/resources/requestInfo';

function getNativeAppVersion(): string {
  if (typeof window !== 'undefined' && (window as any).APP_VERSION) {
    return (window as any).APP_VERSION;
  }
  return '1.0.0';
}

function getIpsCodes(): string | undefined {
  return undefined;
}

export async function loggerSendingData({
  type,
  data,
}: {
  type: string;
  data: any;
}): Promise<any> {
  try {
    const appVersion = getNativeAppVersion();
    const ipCode = getIpsCodes();

    const dataTemp = {
      ...data,
      extraInfo: {
        appVersion,
        platform: 'web',
        IPCode: ipCode,
      },
    };

    const response = await axiosInstance.post('/frontend-log', {
      type,
      data: dataTemp,
    });

    return response.data;
  } catch (error: any) {
    console.warn('Logger error (non-critical):', error);
    return Promise.reject(error.response?.data?.message || error.message);
  }
}
